import { AvailableSuitesResponse, RealSuiteNumber } from "@ssc-booking/api-contracts"
import * as Occupancy from "@ssc-booking/api-contracts/src/occupancy"
import { CruiseCode } from '@ssc-booking/functional-support';
import * as PositiveInt from '@ssc-booking/functional-support/src/positive-int';
import { cruiseCode } from "./cruisecode"

export default AvailableSuitesResponse.build({
    cruiseCode: CruiseCode.buildUnsafe(cruiseCode),
    occupancy: Occupancy.of(2),
    fareCode: "DoorToDoorV2",
    suiteCategory: "CV",
    suites: [
        {
            deck: PositiveInt.buildUnsafe(5),
            number: RealSuiteNumber.buildUnsafe("502"),
            maxGuests: PositiveInt.buildUnsafe(2),
        },
        {
            deck: PositiveInt.buildUnsafe(5),
            number: RealSuiteNumber.buildUnsafe("510"),
            maxGuests: PositiveInt.buildUnsafe(2),
        },
        {
            deck: PositiveInt.buildUnsafe(5),
            number: RealSuiteNumber.buildUnsafe("519"),
            maxGuests: PositiveInt.buildUnsafe(2),
        },
        {
            deck: PositiveInt.buildUnsafe(6),
            number: RealSuiteNumber.buildUnsafe("601"),
            maxGuests: PositiveInt.buildUnsafe(2),
        },
        {
            deck: PositiveInt.buildUnsafe(6),
            number: RealSuiteNumber.buildUnsafe("603"),
            maxGuests: PositiveInt.buildUnsafe(2),
        },
        {
            deck: PositiveInt.buildUnsafe(6),
            number: RealSuiteNumber.buildUnsafe("606"),
            maxGuests: PositiveInt.buildUnsafe(2),
        },
    ],
})
